import { MessageCircle, Flower2 } from "lucide-react";
import { WHATSAPP_CARDS_URL } from "../constants";
import { Reveal } from "./Reveal";

export const FlowerCards = () => (
    <section
        id="flower-cards"
        data-testid="flower-cards-section"
        className="scroll-mt-24 overflow-hidden py-20 lg:py-28"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
                <div className="order-2 lg:order-1">
                    <Reveal delay={0.15}>
                        <div className="grid grid-cols-2 items-start gap-5">
                            <img
                                src="/flower-cards-spread.jpg"
                                alt="علبة بطاقات «أي زهرة أنتِ؟» من إبداع مياسة بتصميم ورود ملوّنة"
                                data-testid="flower-cards-image-box"
                                loading="lazy"
                                className="w-full rounded-[2rem] object-cover aspect-[3/4] soft-shadow"
                            />
                            <img
                                src="/flower-cards-box.jpg"
                                alt="بطاقات «أي زهرة أنتِ؟» مبعثرة ونساء يخترن بطاقاتهن"
                                data-testid="flower-cards-image-spread"
                                loading="lazy"
                                className="mt-10 w-full rounded-[2rem] object-cover aspect-[4/5] soft-shadow"
                            />
                        </div>
                    </Reveal>
                </div>

                <div className="order-1 lg:order-2">
                    <Reveal>
                        <p className="mb-3 flex items-center gap-2 text-sm font-bold text-miam-rose">
                            <Flower2 className="h-4 w-4" aria-hidden="true" />
                            من إبداع مياسة
                        </p>
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                            بطاقات «أي زهرة{" "}
                            <span className="italic text-miam-rose">أنتِ؟</span>»
                        </h2>
                        <p className="mt-6 text-base text-miam-muted leading-loose">
                            بطاقات إلهام صمّمتها مياسة بمحبة. كل زهرة تحمل رسالة، وكل
                            اختيار ينبع من الداخل: أغمضي عينيك، تنفّسي بعمق، واختاري
                            البطاقة التي تناديكِ — رسالتها ليست عشوائية، اقرئيها بهدوء
                            ودعيها تلامس قلبك.
                        </p>
                        <p className="mt-4 text-base text-miam-muted leading-loose">
                            البطاقات متوفّرة للشراء في العيادة، ويمكنك أيضاً طلبها مباشرة
                            عبر واتساب.
                        </p>
                        <p
                            data-testid="flower-cards-price"
                            className="mt-8 font-heading text-3xl font-bold text-miam-green-dark"
                        >
                            170 ₪
                        </p>
                        <div className="mt-6">
                            <a
                                href={WHATSAPP_CARDS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="flower-cards-order-button"
                                className="inline-flex items-center gap-2 rounded-full bg-miam-rose px-8 py-4 text-base font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-rose-dark hover:shadow-lg"
                            >
                                <MessageCircle className="h-5 w-5" aria-hidden="true" />
                                اطلبي البطاقات عبر واتساب
                            </a>
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
